import { T } from 'gt-react';
import { Link as RouterLink, useLocation } from '@tanstack/react-router';
import {
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@/components/ui/sidebar';

export function OrderStatusNavItem({
  type,
}: {
  type: 'purchase' | 'transfer';
}) {
  const { pathname } = useLocation();
  const to =
    type === 'purchase'
      ? '/procurement/purchase-orders'
      : '/procurement/transfer-order-status';

  return (
    <SidebarMenuSub>
      <SidebarMenuSubItem>
        <SidebarMenuSubButton asChild isActive={pathname === to}>
          <RouterLink to={to}>
            <span className="truncate">
              {type === 'purchase' ? (
                <T context="purchase order status sidebar sub-item">
                  PO Status
                </T>
              ) : (
                <T context="transfer order status sidebar sub-item">
                  Transfer Order Status
                </T>
              )}
            </span>
          </RouterLink>
        </SidebarMenuSubButton>
      </SidebarMenuSubItem>
    </SidebarMenuSub>
  );
}
